import purchaseButtonActionApi from '../../../api/purchase/purchaseButtonActionApi';
import { ApiResponse } from '../../../types/common/ApiResponse';
import { purchaseApi } from '../../../api';

const PurchaseButtonActionService = {
  /**
   * 🧾 Descarga el JSON de una compra
   */
  downloadJson: async (purchaseId: number): Promise<void> => {
    await purchaseButtonActionApi.downloadJsonFile(`/json/${purchaseId}`);
  },

  /**
   * 📬 Envía por correo
   */
  sendByEmail: async (purchaseId: number): Promise<ApiResponse<{ sent: boolean; recipient: string; subject: string; message: string }>> => {
    const response = await purchaseApi.addWithoutData(`/${purchaseId}/email`);
    return response.data;
  },

  getDteError: async (purchaseId: number) => {
    const response = await purchaseApi.fetchCustom(`/${purchaseId}/dte-response`);
    return response.data;
  },

  downloadDteResponse: async (purchaseId: number): Promise<void> => {
    await purchaseApi.downloadBlobGet(
      `/${purchaseId}/dte-response/download`,
      `respuesta-hacienda-compra-${purchaseId}.json`,
    );
  },

  /**
   * 🔍 Consulta DTE
   */
  consultDTE: async (purchaseId: number): Promise<ApiResponse<any>> => {
    const response = await purchaseButtonActionApi.fetchCustom(`/consult-dte/${purchaseId}`);
    return response.data;
  },

  /**
  * 🛑 Anulación técnica (DTE_REJECTED)
  */
  forceAnnulRejectedPurchase: async (
    purchaseId: number
  ): Promise<ApiResponse<any>> => {
    const response = await purchaseButtonActionApi.addWithoutData(
      `/force-annul/${purchaseId}`
    );
    return response.data;
  },

  /**
   * 🔄 Reenviar DTE (compra rechazada)
   */
  resendDte: async (purchaseId: number): Promise<ApiResponse<any>> => {
    const response = await purchaseButtonActionApi.addWithoutData(
      `/resend-dte/${purchaseId}`
    );
    return response.data;
  },
};

export default PurchaseButtonActionService;
